import React from 'react';
import PropTypes from 'prop-types';
import momentTz from 'moment-timezone';
import { FormattedMessage } from 'react-intl';

export const getDisplayDateTime = ({ timeZoneId = '', schedule = [] }) => {
  function momentifyDate (dateTime) {
    const { date, time } = dateTime;
    // uses global moment function
    const momentDateTime = momentTz.tz(`${date.y}-${date.m}-${date.d} ${time.h}:${time.m}`, 'YYYY-MM-DD HH:mm', timeZoneId);
    return momentDateTime;
  }

  function returnBookingDateRange (bk) {
    const bookingSchedule = bk || [];
    return bookingSchedule.map((session) => {
      const { start, end } = session;
      let endsNextDay;
      const startDateTime = start ? momentifyDate(start, timeZoneId) : null;
      const endDateTime = end ? momentifyDate(end, timeZoneId) : null;
      if (start && end) {
        endsNextDay = (startDateTime.date() !== endDateTime.date());
      }
      return {
        startDateTime,
        endDateTime,
        endsNextDay,
        start,
        end
      };
    });
  }
  return returnBookingDateRange(schedule);
};

export class Schedule extends React.Component {
  constructor (props) {
    super(props);
    this.checkForDateTime = this.checkForDateTime.bind(this);
  }

  checkForDateTime (time) {
    const { start, end, startDateTime, endDateTime } = time;
    if ((start && start.time.h) && (end && (null !== end.time.h))) {
      return <span>{startDateTime.format('h:mm a')} - {endDateTime.format('h:mm a')} {startDateTime.format('z')} {time.endsNextDay ? <FormattedMessage id="hosting.schedule.next_day" defaultMessage=" (next day)"/> : null}</span>;
    }
    return <FormattedMessage id="hosting.schedule.time_not_specified" defaultMessage="Time not specified"/>;
  }

  render () {
    const displayDateTime = getDisplayDateTime(this.props);
    const { schedule, flexible, customClass } = this.props;
    return (
      <div>
        { flexible ? <p className="flexible">My dates are flexible</p> : '' }
        { schedule && (0 < schedule.length) ? displayDateTime.map((time, i) => <div className={`date-time-wrapper ${customClass}`} key={i} data-testing-id="booking-schedule">
          <div>
            {(time.start && time.start.date) ? time.startDateTime.format('ddd, MMM D, YYYY') : ''}
          </div>
          <div>
            {this.checkForDateTime(time)}
          </div>
        </div>
        ) : flexible ? '' : <FormattedMessage id="hosting.schedule.not_specified" defaultMessage="Not specified"/> }
      </div>
    );
  }
}

getDisplayDateTime.propTypes = {
  schedule: PropTypes.object,
  flexible: PropTypes.bool
};

Schedule.propTypes = {
  schedule: PropTypes.object,
  flexible: PropTypes.bool,
  customClass: PropTypes.string
};
